import { SSIBlock } from '@components/ssi-block';

import { BannerSlugType, partials } from '@helpers/partials';

type TopBannerProps = {
    slug: BannerSlugType;
};

export function TopBanner({ slug }: Readonly<TopBannerProps>) {
    return <SSIBlock url={partials.BANNER(slug)} />;
}
